const API_URLS = {
    'BASE_API_URL': import.meta.env.VITE_APP_BASE_API_URL,
    'AUTH': {
        'INSTALL': '/shopify/install/',
        'CALLBACK': (public_id: string) => `/shopify/callback/${public_id}/`,
        'VERIFY': (public_id: string) => `/shopify/verify/${public_id}/`,
    },
    'APPS': {
        'GET': '/shopify/apps/',
        'DETAIL': (public_id: string) => `/shopify/app/${public_id}/`,
    },
    'SHOPIFY': {
        'PRODUCTS': '/shopify/products/',
        'THEME_FILES': '/shopify/theme-files/',
        'IMAGE': {
            'SAVE_SHOPIFY_IMAGE': (product_id: string) => `/shopify/save-local-product-image/${product_id}/`,
            'RETRIEVE':  (public_id: string) => `/shopify/image/${public_id}/`,
            'IMAGE_GENERATION_DATA': (public_id: string) => `/shopify/collection/${public_id}/generate-images/`,
            'DOWNLOAD': (public_id: string, category: string | undefined | null) => `/shopify/image-download/${public_id}/?category=${category ?? 'undefined'}`,
            'ALT_DOWNLOAD': (public_id: string, type: string) => `/shopify/image/${public_id}/download/?type=${type}`,
            'SAVE': (public_id: string) => `/shopify/image/${public_id}/`,
            'PRODUCTS': '/shopify/image/products/',
            'PRODUCT': (public_id: string) => `/shopify/product/${public_id}/`,
            'PRODUCT_RM_BCK': (public_id: string) => `/shopify/product/${public_id}/remove-background/`,
            'REMOVE_BACKGROUND': '/shopify/remove-background/',
            'REMOVE_BACKGROUND_DETAIL': (public_id: string) => `/shopify/remove-background-detail/${public_id}/`,
            'GALLERIES': '/shopify/galleries/',
            'GALLERY_IMAGES': (public_id: string) => `/shopify/gallery/${public_id}/images/`,
            'DELETE': (public_id: string) => `/shopify/${public_id}/delete/`,
            'GET_REPLACE_URL': '/shopify/get-replace-img-url/',
        },
        'LAYER': {
            'CREATE': (public_id: string) =>`/shopify/image/${public_id}/add-layer/`,
            'MERGE': (public_id: string) => `/shopify/image/${public_id}/merge/`,
            'ACTIVATE_MASK': (public_id: string) => `/shopify/layer/${public_id}/activate-mask/`,
            'UPDATE_MASK': (public_id: string) => `/shopify/layer/${public_id}/update-mask/`,
            'REMOVE_BACKGROUND': (public_id: string) => `/shopify/layer/${public_id}/remove-background/`,
            'DELETE': (public_id: string) =>  `/shopify/layer/${public_id}/delete-layer/`,
            'ENHANCE': (public_id: string) => `/shopify/layer/${public_id}/enhance/`,
        },
        'COLLECTION': {
            'QUEUE_DOWNLOAD': (public_id: string) => `/shopify/collection-queue-download/${public_id}/`,
        },
        'MODELS': {
            'ALL': '/shopify/models/',
            'SPECIFIC': (public_id: string, category: string | null) =>
                `/shopify/model/${public_id}/${category ? `?category=${category}` : ''}`,
        },
        'COLLECTIONS': {
            'ALL': (limit: string) => `/shopify/collections/?limit=${limit}`,
            'CREATE': `/shopify/collections/`,
            'SPECIFIC': (public_id: string) => `/shopify/collection/${public_id}/`,
            'GENERATE_INFLUENCER': (public_id: string) => `/shopify/collection/${public_id}/generate-influencer/`,
            'TRAINING_STATUS': (public_id: string) => `/shopify/collection/${public_id}/training/status/`,
            'TRAIN': (public_id: string) => `/shopify/collection/${public_id}/train/`,
            'GENERATE_IMAGE_POSITIONS': (public_id: string) => `/shopify/collection/${public_id}/generate-image-positions/`,
            'IMAGE': {
                'UPLOAD': '/shopify/images/',
                'DELETE': (public_id: number) => `/shopify/image/${public_id}/`,
            }
        }
    },
    'BILLING': {
        'STATUS': '/shopify/billing/status/',
        'CREATE': '/shopify/billing/create/',
        'CANCEL': '/shopify/billing/cancel/',
        'CALLBACK': '/shopify/billing/callback/',
    }
}

export default API_URLS;